module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "breadcrumb",
    class: {
      active: _vm.isActive, completed: _vm.completed
    },
    style: ({
      width: _vm.width + '%'
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.click($event)
      }
    }
  }, [_c('span', {
    staticClass: "mid"
  }), _vm._v(" "), _c('span', {
    staticClass: "front"
  }), _vm._v(" "), _c('p', {
    staticClass: "breadcrumb-step-name",
    class: {
      completed: _vm.completed
    }
  }, [_vm._v("\n    " + _vm._s(_vm.header) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1072923b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Radius/Breadcrumb/BreadcrumbElement.vue
// module id = GaDv
// module chunks = 1